import * as React from "react";
import { cn } from "@finster/ui";
import { ScrollText, X } from "lucide-react";
import type { SelectedSkillReference, SkillDensity } from "../types";

export interface SkillChipProps {
  skill: SelectedSkillReference;
  density: SkillDensity;
  disabled?: boolean;
  onRemove?: () => void;
  className?: string;
}

export const SkillChip: React.FC<SkillChipProps> = ({
  skill,
  density,
  disabled = false,
  onRemove,
  className,
}) => (
  <span
    className={cn(
      "group inline-flex max-w-full shrink-0 items-center rounded-full",
      "bg-background-tertiary text-foreground",
      density === "compact" ? "min-h-5 gap-1 px-1.5" : "min-h-7 gap-1.5 px-2",
      disabled && "opacity-60",
      className
    )}
    role="group"
    aria-label={`Selected skill /${skill.slug}`}
  >
    <ScrollText className="size-4 shrink-0" aria-hidden />
    <span className="max-w-40 truncate text-xs font-medium leading-[18px]" title={`/${skill.slug}`}>
      /{skill.slug}
    </span>
    {onRemove ? (
      <button
        type="button"
        disabled={disabled}
        onClick={onRemove}
        aria-label={`Remove /${skill.slug}`}
        className={cn(
          "flex max-w-0 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full border-0 bg-transparent p-0 opacity-0",
          "text-muted-foreground transition-[max-width,opacity,color]",
          "group-hover:max-w-4 group-hover:opacity-100 hover:text-foreground",
          "focus:max-w-4 focus:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring-focus",
          disabled && "pointer-events-none"
        )}
      >
        <X className="size-3" aria-hidden />
      </button>
    ) : null}
  </span>
);
